import { SettingsSubModule } from '../utils/settings-sub-module';
import { SettingValue } from '../utils/setting-value';
import { SettingsModule } from '../utils/settings-module';
import { StringHash } from '@app/shared/utils/utils-types';
import { DashletSettings } from '@app/ti-components/dashboard/services/dashlet';

const ModulesTitles = 'Modules.Titles';
const ModulesIcons = 'Modules.Icons';
const ModulesSortings = 'Modules.Sortings';
const MenuItemsPerLine = 'Modules.MenuItemsPerLine';

const Modals = 'Modals.General';

const DashboardDashlets = 'Dashboard.Dashlets';
const DashboardSSUDashlets = 'Dashboard.SSUDashlets';
const DashboardQmsDashlets = 'Dashboard.QmsDashlets';

class ModulesConfig extends SettingsSubModule {
  @SettingsSubModule.value(ModulesTitles, '', {
    setterConverter: (value: StringHash<string>) => JSON.stringify(value),
    getterConverter(value: string): StringHash<string> {
      let result;
      try {
        result = JSON.parse(value);
      } catch (ex) {}

      return result || {};
    },
  })
  titles: SettingValue<StringHash<string>>;

  @SettingsSubModule.value(ModulesIcons, '', {
    setterConverter: (value: StringHash<string>) => JSON.stringify(value),
    getterConverter: (value: string) => {
      let result;
      try {
        result = JSON.parse(value);
      } catch {
        result = {};
      }
      return result;
    },
  })
  icons: SettingValue<StringHash<string>>;

  @SettingsSubModule.value(ModulesSortings, '', {
    setterConverter: (value: StringHash<string>) => JSON.stringify(value),
    getterConverter: (value: string) => {
      let result;
      try {
        result = JSON.parse(value);
      } catch {
        result = {};
      }
      return result;
    },
  })
  modulesSortings: SettingValue<StringHash<string>>;

  @SettingsSubModule.value(MenuItemsPerLine, 4, {
    getterConverter(value: string): any {
      return value || 4;
    },
  })
  menuItemsPerLine: SettingValue<number>;

  @SettingsSubModule.value(Modals, '', {
    setterConverter: (value: StringHash<string>) => JSON.stringify(value),
    getterConverter: (value: string) => {
      let result;
      try {
        result = JSON.parse(value);
      } catch {
        result = {};
      }
      return result;
    },
  })
  modals: SettingValue<any>;
}

class ModalsConfig extends SettingsSubModule {
  @SettingsSubModule.value(Modals, '', {
    setterConverter: (value: StringHash<string>) => JSON.stringify(value),
    getterConverter: (value: string) => {
      let result;
      try {
        result = JSON.parse(value);
      } catch {
        result = {};
      }
      return result;
    },
  })
  general: SettingValue<any>;
}

class DashboardConfig extends SettingsSubModule {
  get isEmpty() {
    return !this.mainStore[DashboardDashlets];
  }
  get isSSUEmpty() {
    return !this.mainStore[DashboardSSUDashlets];
  }

  get isQmsEmpty() {
    return !this.mainStore[DashboardQmsDashlets];
  }

  @SettingsSubModule.value(DashboardDashlets, '', {
    setterConverter: (value: DashletSettings[]) => JSON.stringify(value),
    getterConverter(value: string): DashletSettings[] {
      try {
        return JSON.parse(value) || [];
      } catch {
        return [];
      }
    },
  })
  dashlets: SettingValue<DashletSettings[] | DashletSettings[][]>;

  @SettingsSubModule.value(DashboardSSUDashlets, '', {
    setterConverter: (value: DashletSettings[]) => JSON.stringify(value),
    getterConverter(value: string): DashletSettings[] {
      try {
        return JSON.parse(value) || [];
      } catch {
        return [];
      }
    },
  })
  startupDashlets: SettingValue<DashletSettings[] | DashletSettings[][]>;

  @SettingsSubModule.value(DashboardQmsDashlets, '', {
    setterConverter: (value: DashletSettings[]) => JSON.stringify(value),
    getterConverter(value: string): DashletSettings[] {
      try {
        return JSON.parse(value) || [];
      } catch {
        return [];
      }
    },
  })
  qmsDashlets: SettingValue<DashletSettings[] | DashletSettings[][]>;
}

export class UiConfigModule extends SettingsModule {
  @SettingsModule.value(DashboardConfig) dashboard: DashboardConfig;
  @SettingsModule.value(ModulesConfig) modules: ModulesConfig;
  @SettingsModule.value(ModalsConfig) modals: ModalsConfig;
}
